<template>
  <div class="h-sticky h-sticky--catalogo">
    <header-partial/>
  </div>
</template>

<script>
import HeaderPartial from "./components/HeaderPartial";

export default {
  name: "HeaderCatalogo",
  components: {
    HeaderPartial
  }
}
</script>